import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const benefits = ['Entender tus cambios sin culpa ni confusión', 'Saber exactamente qué hacer cada semana según tu fase', 'Organizar tu energía de forma realista', 'Reducir la frustración y la ansiedad mensual', 'Sentirte en control sin exigirte de más'];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-16 md:py-24 px-4" data-id="element-13">
      <div className="max-w-4xl mx-auto" data-id="element-14">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="font-serif text-3xl md:text-4xl text-center text-text-primary mb-12" data-id="element-15">
          ¿Qué vas a lograr con esta guía?
        </motion.h2>

        <div className="space-y-4 mb-10" data-id="element-16">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex gap-4 items-center bg-white/50 p-5 rounded-2xl" data-id="element-17">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary flex items-center justify-center" data-id="element-18">
                <Check className="w-5 h-5 text-white" strokeWidth={2.5} data-id="element-19" />
              </div>
              <p className="text-lg text-text-primary" data-id="element-20">{benefit}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="text-center" data-id="element-21">
          <a href="#comprar" className="inline-block bg-primary text-white px-8 py-4 rounded-full text-lg font-medium shadow-lg hover:bg-accent transition-colors" data-id="element-22">
            Quiero empezar hoy
          </a>
        </motion.div>
      </div>
    </section>;
}